<num-modal-window [displaySaveButtons]="false">
  <num-error-log-header></num-error-log-header>

  @if (errors.length > 0) {
  <div class="error-summary">
    <span [innerHTML]="'APPLAYOUT.HEADER.ERROR_LOG.MODAL.DESCRIPTION' | translate"></span>
  </div>
  <div class="error-log-content">
    @if (errors.length > 0) {
    <div class="error-list">
      @for (error of errors; track error) {
      <num-error-log-item [error]="error"></num-error-log-item>
      }
    </div>
    }
  </div>
  } @if (upgrades$ | async; as upgrades) { @if (upgrades.length > 0) {
  <div class="error-summary">
    <span [innerHTML]="'APPLAYOUT.HEADER.UPGRADE_LOG.MODAL.DESCRIPTION' | translate"></span>
  </div>
  <div class="error-log-content">
    <div class="error-list">
      @for (upgrade of upgrades; track upgrade) {
      <num-error-log-item [profileUpgrade]="upgrade"> </num-error-log-item>
      }
    </div>
  </div>
  } }
  <num-error-log-actions></num-error-log-actions>
</num-modal-window>
